// Theme / language persistence. localStorage can be missing or throw (private
// mode, blocked site data), so every access is guarded and falls back cleanly.
const THEME_KEY = 'theme';
const LANGUAGE_KEY = 'language';

const THEMES = ['light', 'dark'];
const LANGUAGES = ['en', 'zh'];

// <html lang> value for each UI language.
export const htmlLang = { en: 'en', zh: 'zh-Hant' };

function read(key) {
    try {
        return window.localStorage.getItem(key);
    } catch {
        return null;
    }
}

function write(key, value) {
    try {
        window.localStorage.setItem(key, value);
    } catch {
        // Storage unavailable: the choice just won't survive a reload.
    }
}

function systemPrefersDark() {
    try {
        return window.matchMedia('(prefers-color-scheme: dark)').matches;
    } catch {
        return false;
    }
}

// Saved choice wins; otherwise follow the OS color scheme.
export function getInitialTheme() {
    const saved = read(THEME_KEY);
    if (THEMES.includes(saved)) return saved;
    return systemPrefersDark() ? 'dark' : 'light';
}

export function getInitialLanguage() {
    const saved = read(LANGUAGE_KEY);
    return LANGUAGES.includes(saved) ? saved : 'en';
}

// Only called on an explicit toggle, so an untouched visitor keeps following
// their OS setting instead of having it frozen on first visit.
export const saveTheme = (theme) => write(THEME_KEY, theme);
export const saveLanguage = (language) => write(LANGUAGE_KEY, language);
